// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ht-0";